module.exports = __webpack_public_path__ + "img/Montenegro.442bc6f7.svg";